export function encodeQueryParams(params) {
    const query = Object.keys(params)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&');
    if(query !== '') {
        return '?' + query;
    } else {
        return '';
    }
}


// WEBPACK FOOTER //
// ./src/utils/url.js